import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { getToken } from '../../../services/otpAuthService';

const SOCKET_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/graphql', '').replace('/api', '')
  : 'http://localhost:5000';

export function useDiscussionSocket(
  discussionId: string | undefined,
  onNewReply: (reply: any) => void,
  onReactionUpdate: (reactions: any[]) => void
) {
  const socketRef = useRef<Socket | null>(null);
  const onNewReplyRef = useRef(onNewReply);
  const onReactionUpdateRef = useRef(onReactionUpdate);
  onNewReplyRef.current = onNewReply;
  onReactionUpdateRef.current = onReactionUpdate;

  useEffect(() => {
    if (!discussionId) return;

    const token = getToken();
    if (!token) return;

    const socket = io(`${SOCKET_URL}/community-v2`, {
      auth: { token },
      transports: ['websocket', 'polling']
    });
    socketRef.current = socket;

    socket.on('connect', () => {
      socket.emit('join_discussion', { discussionId });
    });

    socket.on('discussion_new_reply', (data: { discussionId: string; reply: any }) => {
      if (data.discussionId === discussionId) {
        onNewReplyRef.current({ reactions: [], attachments: [], mentions: [], ...data.reply });
      }
    });

    socket.on('discussion_reaction_update', (data: { discussionId: string; reactions: any[] }) => {
      if (data.discussionId === discussionId) {
        onReactionUpdateRef.current(data.reactions);
      }
    });

    return () => {
      socket.emit('leave_discussion', { discussionId });
      socket.disconnect();
      socketRef.current = null;
    };
  }, [discussionId]);
}
